<script lang="ts" module>
    import { Slot, SLOT_TYPES } from "../model/Slot";

    /**
     * Calculates the suggest bootstrap col width to show asset candidates for this slot based on it's aspect ratio
     * @param slot
     */
    export function calculateCardColsForSlotAssetCandidates(
        slot: Slot,
    ): number {
        let cardGridCols = 3;
        // Calculate cardGridCols
        let aspectRatio = slot.type == SLOT_TYPES.TEXTURE ? slot.dimensions[0] / slot.dimensions[1] : 1;
        if (aspectRatio > 1.5) {
            cardGridCols = 6;
        } else if (aspectRatio < 0.5) {
            cardGridCols = 2;
        } else {
            cardGridCols = 3;
        }
        return cardGridCols;
    }
</script>
